import React from "react";
import "./index.less";
import img3 from "@/assets/img/img3.jpg";

const Page4: React.FC = () => {
  return (
    <section className="page4">
      <div className="info">
        <div className="text">
          東銀座駅から徒歩3分、銀座の静かな一角に佇む。銀座の夜景とライブ感あふれる調理風景が楽しめる特別な場所。大切な人とのディナーや記念日に、銀座でしか味わえない上海料理の真髄をご堪能ください。
        </div>
      </div>
      <div className="img">
        <img src={img3} alt="" />
      </div>
    </section>
  );
};

export default Page4;
